import React, { useState, useCallback, useEffect } from "react";
import { Col, Input, Label, Row, TabPane, Spinner, Button, FormGroup, InputGroup, InputGroupText, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import { APIClient } from "../../../../helpers/api_helper";
import { NumericFormat } from "react-number-format";
import InputMask from "react-input-mask";
import ConsultationModal from "./ConsultationModal";

const apiClient = new APIClient();

const CPFDisplay = ({ data }) => {
  return (
    <div className="p-3">
      <h5 className="mb-4">Dados do CPF</h5>
      <Row>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">CPF:</Label>
            <p>{data.numero_de_cpf}</p>
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">Nome:</Label>
            <p>{data.nome_da_pf}</p>
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">Data de Nascimento:</Label>
            <p>{data.data_nascimento}</p>
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">Situação Cadastral:</Label>
            <p>{data.situacao_cadastral}</p>
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">Data de Inscrição:</Label>
            <p>{data.data_inscricao}</p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const CNPJDisplay = ({ data }) => {
  return (
    <div className="p-3">
      <h5 className="mb-4">Dados do CNPJ</h5>
      
      <Card className="mb-4">
        <CardBody>
          <h6 className="mb-3">Informações Básicas</h6>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">CNPJ:</Label>
                <p>{data.numero_de_inscricao}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Nome:</Label>
                <p>{data.nome}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Nome Fantasia:</Label>
                <p>{data.fantasia}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Tipo:</Label>
                <p>{data.tipo}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Data de Abertura:</Label>
                <p>{data.abertura}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Porte:</Label>
                <p>{data.porte}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Natureza Jurídica:</Label>
                <p>{data.natureza_juridica}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Capital Social:</Label>
                <p>R$ {parseFloat(data.capital_social).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card className="mb-4">
        <CardBody>
          <h6 className="mb-3">Atividade Principal</h6>
          <div className="mb-3">
            <Label className="fw-bold">Descrição:</Label>
            <p>{data.atividade_principal.text}</p>
          </div>
          <div className="mb-3">
            <Label className="fw-bold">Código:</Label>
            <p>{data.atividade_principal.code}</p>
          </div>
        </CardBody>
      </Card>

      {data.atividades_secundarias && data.atividades_secundarias.length > 0 && (
        <Card className="mb-4">
          <CardBody>
            <h6 className="mb-3">Atividades Secundárias</h6>
            {data.atividades_secundarias.map((atividade, index) => (
              <div key={index} className="mb-3">
                <Label className="fw-bold">Atividade {index + 1}:</Label>
                <p>{atividade.text}</p>
                <small className="text-muted">Código: {atividade.code}</small>
              </div>
            ))}
          </CardBody>
        </Card>
      )}

      <Card className="mb-4">
        <CardBody>
          <h6 className="mb-3">Endereço</h6>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Logradouro:</Label>
                <p>{data.logradouro}, {data.numero}{data.complemento ? ` - ${data.complemento}` : ''}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Bairro:</Label>
                <p>{data.bairro}</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <Label className="fw-bold">Cidade:</Label>
                <p>{data.municipio}</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <Label className="fw-bold">UF:</Label>
                <p>{data.uf}</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <Label className="fw-bold">CEP:</Label>
                <p>{data.cep}</p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <h6 className="mb-3">Contato</h6>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Email:</Label>
                <p>{data.email}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Telefone:</Label>
                <p>{data.telefone}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Situação:</Label>
                <p>{data.situacao}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Data da Situação:</Label>
                <p>{data.dt_situacao_cadastral}</p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

const TabConfig = () => {
  const [loading, setLoading] = useState(false);
  const [carteiraEther, setCarteiraEther] = useState("");
  const [carteiraBitcoin, setCarteiraBitcoin] = useState("");
  const [taxaCompraVenda, setTaxaCompraVenda] = useState(0);
  const [taxaDCA, setTaxaDCA] = useState(0);
  const [fecthData, setFetchData] = useState(false);
  
  // Consulta CPF/CNPJ states
  const [documentType, setDocumentType] = useState("cpf");
  const [documentNumber, setDocumentNumber] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [consultationResult, setConsultationResult] = useState(null);
  const [consulting, setConsulting] = useState(false);

  const fetchConfigData = useCallback(async () => {
    setLoading(true);
    const response = await apiClient.get("/config-system");

    if (response.sucesso) {
      response.dados.forEach((item) => {
        switch (item.campo) {
          case "wallet-ether":
            setCarteiraEther(item.value);
            break;
          case "wallet-hybrid":
            setCarteiraBitcoin(item.value);
            break;
          case "taxa_compra_venda":
            setTaxaCompraVenda(parseFloat(item.value));
            break;
          case "taxa_dca":
            setTaxaDCA(parseFloat(item.value));
            break;
          default:
            break;
        }
      });
    } else {
      toast.error(response.mensagem);
    }
    setLoading(false);
    setFetchData(true);
  }, []);

  useEffect(() => {
    if (!fecthData) fetchConfigData();
  }, [fetchConfigData, fecthData]);

  const handleEdit = async () => {
    const payload = {
      "wallet-ether": carteiraEther,
      "wallet-hybrid": carteiraBitcoin,
      taxa_compra_venda: taxaCompraVenda,
      taxa_dca: taxaDCA,
      document_type: documentType,
      document_number: documentNumber,
      birth_date: birthDate,
    };

    const response = await apiClient.put("/config-system", payload);

    if (response.sucesso) {
      toast.success("Configurações atualizadas com sucesso.");
    } else {
      toast.error(response.mensagem);
    }
  };

  const handleConsultation = async () => {
    setConsulting(true);
    try {
      const payload = {
        [documentType]: documentNumber.replace(/[^\d]/g, '')
      };

      if (documentType === "cpf") {
        payload.data_nascimento = birthDate;
      }

      const response = await apiClient.post("/config-system/consultar-cpf-cnpj", payload);

      if (response.sucesso) {
        setConsultationResult(response.dados);
        setModalOpen(true);
      } else {
        toast.error(response.mensagem);
      }
    } catch (error) {
      toast.error("Erro ao realizar a consulta");
    } finally {
      setConsulting(false);
    }
  };

  return (
    <TabPane tabId="1">
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Row>
            <Col lg={12}>
              <div className="mb-4">
                <h4 className="card-title mb-4">Consulta de CPF / CNPJ</h4>
                <Row>
                  <Col lg={12}>
                    <FormGroup>
                      <Label className="form-label">Tipo de Documento</Label>
                      <div className="d-flex gap-3">
                        <div className="form-check">
                          <Input
                            type="radio"
                            id="cpf"
                            name="documentType"
                            value="cpf"
                            checked={documentType === "cpf"}
                            onChange={(e) => setDocumentType(e.target.value)}
                          />
                          <Label className="form-check-label" htmlFor="cpf">
                            CPF
                          </Label>
                        </div>
                        <div className="form-check">
                          <Input
                            type="radio"
                            id="cnpj"
                            name="documentType"
                            value="cnpj"
                            checked={documentType === "cnpj"}
                            onChange={(e) => setDocumentType(e.target.value)}
                          />
                          <Label className="form-check-label" htmlFor="cnpj">
                            CNPJ
                          </Label>
                        </div>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label">
                        {documentType === "cpf" ? "CPF" : "CNPJ"}
                      </Label>
                      <InputMask
                        mask={documentType === "cpf" ? "999.999.999-99" : "99.999.999/9999-99"}
                        placeholder={documentType === "cpf" ? "000.000.000-00" : "00.000.000/0000-00"}
                        value={documentNumber}
                        onChange={(e) => setDocumentNumber(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </Col>
                  {documentType === "cpf" && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label className="form-label">Data de Nascimento</Label>
                        <InputMask
                          mask="99/99/9999"
                          value={birthDate}
                          onChange={(e) => setBirthDate(e.target.value)}
                          className="form-control"
                          placeholder="DD/MM/AAAA"
                        />
                      </div>
                    </Col>
                  )}
                  <Col lg={12}>
                    <div className="mb-3">
                      <Button
                        color="primary"
                        className="btn"
                        onClick={handleConsultation}
                        disabled={consulting}
                      >
                        {consulting ? <Spinner size="sm" /> : "Consultar"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <ConsultationModal
            isOpen={modalOpen}
            toggle={() => setModalOpen(!modalOpen)}
            documentType={documentType}
            data={consultationResult}
          />

          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Carteira Ethereum</Label>
                <Input
                  type="text"
                  className="form-control"
                  value={carteiraEther}
                  onChange={(e) => setCarteiraEther(e.target.value)}
                  maxLength={42}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Carteira Bitcoin</Label>
                <Input
                  type="text"
                  className="form-control"
                  value={carteiraBitcoin}
                  onChange={(e) => setCarteiraBitcoin(e.target.value)}
                  maxLength={42}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Taxa Compra/Venda</Label>
                <NumericFormat
                  className="form-control"
                  placeholder="0,00 %"
                  value={taxaCompraVenda}
                  onValueChange={({ value }) =>
                    setTaxaCompraVenda(parseFloat(value))
                  }
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  suffix="%"
                  fixedDecimalScale={true}
                  allowNegative={false}
                />
                <span className="text-muted">
                  Taxa cobrada na compra e venda de criptomoedas.
                </span>
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Taxa DCA</Label>
                <NumericFormat
                  className="form-control"
                  placeholder="0,00 %"
                  value={taxaDCA}
                  onValueChange={({ value }) => setTaxaDCA(parseFloat(value))}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  suffix="%"
                  fixedDecimalScale={true}
                  allowNegative={false}
                />
                <span className="text-muted">
                  Taxa cobrada na compra de criptomoedas via DCA.
                </span>
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <Button
                  color="primary"
                  className="btn mb-4"
                  onClick={handleEdit}
                  disabled={loading}
                >
                  Editar
                </Button>
              </div>
            </Col>
          </Row>
        </>
      )}
    </TabPane>
  );
};

export default TabConfig;
